import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'ui-top-navbar-user-menu',
  imports: [NzAvatarModule, NzDropDownModule, NzIconModule],
  templateUrl: './top-navbar-user-menu.html',
  styleUrl: './top-navbar-user-menu.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopNavbarUserMenuComponent {
  readonly userName = input<string>('Usuário');
  readonly logoutRequested = output<void>();

  protected readonly userInitial = computed(() => {
    const name = this.userName().trim();
    return name ? name.charAt(0).toUpperCase() : 'U';
  });

  protected readonly userMenuOpen = signal(false);

  protected onUserMenuOpenChange(open: boolean): void {
    this.userMenuOpen.set(open);
  }

  onLogout(): void {
    this.logoutRequested.emit();
  }
}
